import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import EntityAttribute from './entity-attribute';
import EntityAttributeDetail from './entity-attribute-detail';
import EntityAttributeUpdate from './entity-attribute-update';
import EntityAttributeDeleteDialog from './entity-attribute-delete-dialog';

const EntityAttributeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<EntityAttribute />} />
    <Route path="new" element={<EntityAttributeUpdate />} />
    <Route path=":id">
      <Route index element={<EntityAttributeDetail />} />
      <Route path="edit" element={<EntityAttributeUpdate />} />
      <Route path="delete" element={<EntityAttributeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default EntityAttributeRoutes;
